var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ul',{staticClass:"list-unstyled chat-list"},_vm._l((_vm.CustomerContacts),function(customerContact,index){return _c('chat-contact',{key:customerContact.id,attrs:{"id":customerContact.id,"contact":customerContact,"active-index":_vm.activeUserIndex},on:{"user-selected":_vm.handleUserSelected}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }